module.exports = __webpack_public_path__ + "img/colorful-separator-3.74186906.svg";